<template>
    <v-container>
        <v-flex xs12 s12 md12>
            <v-toolbar
                    color="secondary"
            >
                <v-toolbar-title>Documents</v-toolbar-title>
            </v-toolbar>
            <v-card>
                <v-container>
                    <v-treeview
                            v-if="documents.length > 0"
                            v-model="tree"
                            :open="open"
                            :items="documents"
                            activatable
                            item-key="name"
                            open-all
                    >
                        <template slot="prepend" slot-scope="{ item, open, leaf }">
                            <v-icon v-if="!item.file" @contextmenu="show($event, item.id)">
                                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else @contextmenu="showFile($event, item.id, item)">
                                {{ files[item.file] }}
                            </v-icon>
                        </template>
                    </v-treeview>
                    <v-menu
                            v-model="showMenuFolder"
                            :position-x="x"
                            :position-y="y"
                            absolute
                            offset-y
                    >
                        <v-list>
                            <v-list-tile
                            >
                                <v-dialog v-model="dialog_upload" persistent max-width="600px">

                                    <v-btn flat block slot="activator"><v-icon left>mdi-file-plus</v-icon> Add file</v-btn>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">Upload files:</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-flex xs12 s12 md12 class="mt-4">
                                                        <vue-dropzone v-if="dialog_upload" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" v-on:vdropzone-success="getDocuments()"></vue-dropzone>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" flat @click="dialog_upload = false">Close</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-menu
                            v-model="showMenuFile"
                            :position-x="x"
                            :position-y="y"
                            absolute
                            offset-y
                    >
                        <v-list v-if="showMenuFile">
                            <v-list-tile
                                    v-if="document.user_id == user.id "
                            >
                                <v-btn flat block @click="deleteFile()"><v-icon left>mdi-delete-circle</v-icon>Delete file</v-btn>

                            </v-list-tile>
                            <v-list-tile
                            >
                                <v-btn v-if="showMenuFile" flat block :href="API_BASE + 'orders/' + order_id + '/pdf/' + document.document.id + '?token=' + document.document.token" target="_blank"><v-icon left>mdi-cloud-download</v-icon>Download</v-btn>

                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-container>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    import { API_BASE } from  '../../../../config';

    export default {
        props: ['order_id'],
        data: function () {
            return {
                dropzoneOptions: {
                    url: '',
                    thumbnailWidth: 150,
                    maxFilesize: 500,
                    headers: {
                        'Authorization': localStorage.getItem('token'),
                        'Autrollization': localStorage.getItem('token'),
                        'Authorization-temp': localStorage.getItem('token')
                    },
                    addRemoveLinks: true,
                },
                documents: [],
                API_BASE: API_BASE,
                open: ['public'],
                files: {
                    html: 'mdi-language-html5',
                    js: 'mdi-nodejs',
                    json: 'mdi-json',
                    md: 'mdi-markdown',
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel',
                    xlsx: 'mdi-file-excel'
                },
                tree: [],
                showMenuFolder: false,
                showMenuFile: false,
                x: 0,
                y: 0,
                folder_id: null,
                document: null,
                dialog_create: false,
                dialog_rename: false,
                dialog_upload: false,
                folder_name: '',
                snackbar: false,
                text: 'Hello, I\'m a snackbar'
            }
        },
        components: {
            vueDropzone: vue2Dropzone
        },
        created() {
            this.getDocuments();
        },
        computed : {
            user: function() {
                return this.$store.getters.getUser;
            }
        },
        methods: {
            getDocuments() {
                this.$store.dispatch('getDirectories', {
                    order_id: this.order_id
                }).then((res) => {
                    this.documents = res.data.data;
                    this.dialog_rename = false;
                    this.dialog_create = false;
                    this.dialog_upload = false;
                    this.showMenuFolder = false;
                    this.showMenuFile = false;
                }).catch((error) => {

                });
            },
            show(e, folder_id) {
                e.preventDefault()
                this.showMenuFolder = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFolder = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.dropzoneOptions.url = API_BASE + 'orders/' + this.order_id + '/folder/' + this.folder_id + '/document';
                })
            },
            showFile(e, folder_id, document) {
                e.preventDefault()
                this.showMenuFile = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFile = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.document = document;
                })
            },
            createFolder() {
                this.$store.dispatch('createFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            renameFolder() {
                this.$store.dispatch('renameFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id,
                    folder_name: this.folder_name
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {

                });
            },
            deleteFile() {
                this.$store.dispatch('deleteFolder', {
                    order_id: this.order_id,
                    folder_id: this.folder_id
                }).then((res) => {
                    this.getDocuments();
                }).catch((error) => {
                    this.text = error.data.mensaje;
                    this.snackbar = true;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/client/orders/components/FilesComponent.vue